<template>
  <div class="navbar-connected-label">
    <span class="label">
      {{ message }}
    </span>
    <b-button class="icon-button" v-b-tooltip.hover.bottom :title="message">
      <icon class="icon" />
    </b-button>
  </div>
</template>

<script>
import Icon from 'vue-material-design-icons/HandshakeOutline';

export default {
  name: 'NavbarConnectedLabel',
  props: {
    message: {
      type: String,
    },
  },
  components: {
    Icon,
  },
};
</script>
